import { render, staticRenderFns } from "./Sns.vue?vue&type=template&id=b33d3f32&scoped=true"
import script from "./Sns.vue?vue&type=script&lang=js"
export * from "./Sns.vue?vue&type=script&lang=js"
import style0 from "./Sns.vue?vue&type=style&index=0&id=b33d3f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d3f32",
  null
  
)

export default component.exports